export const SET_INTERACTIONS = "setInteractions";
export const CLEAR_INTERACTIONS = "clearInteractions";
export const SET_TOTAL_INTERACTIONS = "setTotalInteractions";
export const CLEAR_TOTAL_INTERACTIONS = "clearTotalInteractions";
export const SET_INTERACTION_CATEGORIES = "setInteractionCategories";
export const CLEAR_INTERACTION_CATEGORIES = "clearInteractionCategories";
export const SET_FILTER_INTERACTIONS = "setFilterInteractions";
export const CLEAR_FILTER_INTERACTIONS = "clearFilterInteractions";
